<template>
  <div
    id="RegistrationModalVue"
    :class="{'modal': !isWidget}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    :style="isWidget ? 'padding-left: 0;' : ''"
  >
    <div :class="{'modal-dialog modal-dialog-centered': !isWidget}" class="modal-checkout">
      <div class="modal-content">
        <div class="checkout-content-wrapper">
          <div class="event-information">
            <div class="event-information-inner">
              <modal-header />

              <div class="event-content-wrapper">
                <div class="event-content">
                  <tickets-step
                    v-show="step === '1'"
                  ></tickets-step>

                  <customer-step
                    v-if="step === '1.1'"
                    ref="customerStep"
                    :is-attendee="isAttendee"
                  ></customer-step>

                  <attendees-step
                    v-if="step === '2'"
                    ref="attendeesStep"
                  ></attendees-step>

                  <agenda-step
                    v-if="step === '2.1'"
                    type="modal"
                    ref="agendaStep"
                  ></agenda-step>

                  <payment-step
                    v-if="step === '3'"
                    ref="paymentStep"
                  ></payment-step>

                  <success-step
                    v-if="step === '4'"
                  ></success-step>

                  <modal-footer
                    v-if="!conference?.registration_disabled"
                    ref="modalFooter"
                    :is-attendee.sync="isAttendee"
                    :on-save-customer-step="onSaveCustomerStep"
                    :on-save-attendees-step="onSaveAttendeesStep"
                    :on-save-agenda-step="onSaveAgendaStep"
                  />
                </div>
              </div>
            </div>
          </div>

          <modal-summary
            :isWidget="isWidget"
          />
        </div>

        <div class="close-button" v-if="!isWidget">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" class="fa-regular fa-close"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import store from "../../store";
import ModalHeader from "./ModalHeader";
import ModalSummary from "./ModalSummary";
import ModalFooter from "./ModalFooter";
import TicketsStep from "./TicketsStep";
import CustomerStep from "./CustomerStep";
import AttendeesStep from "./AttendeesStep";
import AgendaStep from "./AgendaStep";
import PaymentStep from "./PaymentStep";
import SuccessStep from "./SuccessStep";

export default {
  props: {
    isWidget: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AttendeesStep,
    TicketsStep,
    CustomerStep,
    AgendaStep,
    PaymentStep,
    SuccessStep,
    ModalSummary,
    ModalHeader,
    ModalFooter
  },
  mounted() {
    this.initModal();
  },
  data() {
    return {
      isAttendee: false
    }
  },
  store,
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "step",
      "isFetching"
    ])
  },
  methods: {
    ...mapActions('basketStore', ['fetchBasket']),

    initModal() {
      setTimeout(() => {
        // Close modal with key ESC
        $("#RegistrationModalVue").modal({
          show: false,
          backdrop: 'static'
        });

        // Fixed body scroll in iphones
        $('#RegistrationModalVue').on("shown.bs.modal", () => {
          $('body').css('width', '100%');
          $("body").css("position", "fixed");
        });

        // Fixed body scroll in iphones
        $('#RegistrationModalVue').on("hide.bs.modal", () => {
          // run method when close modal
          this.hideModal();

          $('body').css('width', 'auto');
          $("body").css("position", "static");
        });
      }, 500);
    },

    showModal(slug, token) {
      this.slug = slug;
      this.token = token;
      $('.preloader').fadeIn();

      if (!this.isWidget) {
        setTimeout(() => {
          $('#RegistrationModalVue').modal({
            'show': true,
            'backdrop': 'static',
            'keyboard': false
          });
        }, 500);
      }

      // set default step
      this.$store.dispatch('basketStore/changeStep', { type: "set", step: '1' });
      this.fetchBasket({slug, token})
        .then(() => {})
        .finally(() => {
          // hide preloader
          $('.preloader').fadeOut();
        });
    },

    hideModal() {
      this.$nextTick(() => {
        this.$refs?.modalFooter?.$refs?.couponForm?.reset();
      });
      this.isAttendee = false;
    },

    onSaveCustomerStep() {
      if (this.$refs.customerStep) {
        this.$refs.customerStep.submitForm();
      } else {
        console.error('Customer form reference not found');
      }
    },

    onSaveAttendeesStep() {
      if (this.$refs.attendeesStep) {
        this.$refs.attendeesStep.submitForm();
      } else {
        console.error('Attendees form reference not found');
      }
    },

    onSaveAgendaStep() {
      if (this.$refs.agendaStep) {
        this.$refs.agendaStep.submitForm();
      } else {
        console.error('Attendees form reference not found');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
